module.exports = __webpack_public_path__ + "static/media/Home_white.3272867a.svg";